import React from "react";
import ReactDOM from "react-dom";
import BaseComponent from "../../baseComponent.js";
import Widget from "../../../core/models/widget.js";
import InternalEvent from "../../../core/constants/internalEvent.js";
import UniqueIdGenerator from "../../../core/utils/uniqueIdGenerator.js";
import WidgetType from "../../../core/constants/widgetType.js";
import WidgetService from "../../../core/services/widgetService.js";
import WidgetActions from "./widgetActions.jsx";
import GaugeWidget from "./gauge/gaugeWidget.jsx";
import TimeSeriesWidget from "./timeseries-chart/timeSeriesWidget.jsx";
import TextualWidget from "./textual/textualWidget.jsx";
import PieWidget from "./pie-chart/pieWidget.jsx";
import TableWidget from "./table/tableWidget.jsx";
import TreeMapWidget from "./treeMap/treeMapWidget.jsx";
import MapWidget from "./map/mapWidget.jsx";
import SpreadsheetWidget from "./spreadsheet/widet.jsx";
import { ControlWidget } from "../control-widget/control-widget.jsx";
import { TechnicalAnalysisWidget } from "./technical-analysis-chart/technicalAnalysisWidget.jsx";
import DashboardService from "../../../core/services/dashboardService.js";
import styles from "./wrapper-widget.scss";
import BulletWidget from "./bullet/bulletWidget.jsx";
import SeparatorWidget from "./separator/separatorWidget.jsx";
import RankingWidget from "./ranking/rankingWidget.jsx";
import TradingViewWidget from "./trading-view/tradingViewWidget.jsx";

export default class WrapperWidget extends BaseComponent {
  constructor(props) {
    super(props);
    this.buttonsClassName = this.props.widget.id + "-widget-button";
    this.state = {
      model: null
    };
  }

  componentDidMount() {
    let widgetId = this.props.widget.id;
    if (!isMobile()) {
      $("#" + widgetId).hover(this.refs.actions.show, this.refs.actions.hide);
    }

    setTimeout(() => {
      this.renderInnerWidget();
    }, 0);
  }

  componentWillUnmount() {
    this.unsubscribeAll();
    ReactDOM.unmountComponentAtNode(this.refs.innerWidget);
  }

  isWidgetInvisible() {
    return this.props.model.metaData.visible && this.props.model.metaData.visible.value === false;
  }

  renderInnerWidget() {
    let innerWidget;

    if (this.isWidgetInvisible()) return;

    switch (this.props.model.type) {
      case WidgetType.TIME_SERIES_VERTICAL:
      case WidgetType.TIME_SERIES: {
        innerWidget =
          <TimeSeriesWidget widget={this.props.widget} model={this.props.model} components={this.props.components}
            dashboardId={this.props.dashboardId}
            onSnapshotLoaded={this.props.onSnapshotLoaded}
            isVertical={this.props.model.type === WidgetType.TIME_SERIES_VERTICAL} />;
        break;
      }
      case WidgetType.TEXTUAL: {
        innerWidget = <TextualWidget model={this.props.model}
          widget={this.props.model}
          togglePreloader={() => true}
          onSnapshotLoaded={this.props.onSnapshotLoaded}
          dashboardId={this.props.dashboardId}
          onStateChange={this.onStateChange} />;
        break;
      }
      case WidgetType.PIE_CHART: {
        innerWidget = <PieWidget widgetId={this.props.model.id}
          togglePreloader={this.togglePreloader}
          widget={this.props.model}
          onSnapshotLoaded={this.props.onSnapshotLoaded}
          legends={this.props.model.legends}
          components={this.props.components} />;
        break;
      }
      case WidgetType.GAUGE: {
        let doesTitleExist = (this.props.model.title != null) && (this.props.model.title.length > 0);

        innerWidget = <GaugeWidget widgetId={this.props.model.id}
          togglePreloader={this.togglePreloader}
          widget={this.props.model}
          onSnapshotLoaded={this.props.onSnapshotLoaded}
          legends={this.props.model.legends}
          componentId={UniqueIdGenerator.id()}
          max={this.props.model.legends[0].parameters.chartTypeParameters.max}
          doesTitleExist={doesTitleExist} />;
        break;
      }
      case WidgetType.TABLE: {
        innerWidget = <TableWidget widgetId={this.props.model.id}
          togglePreloader={this.togglePreloader}
          onSnapshotLoaded={this.props.onSnapshotLoaded}
          model={this.props.model}
          legends={this.props.model.legends}
          componentId={UniqueIdGenerator.id()} />;
        break;
      }
      case WidgetType.TREE_MAP: {
        innerWidget = <TreeMapWidget widgetId={this.props.model.id}
          togglePreloader={this.togglePreloader}
          onSnapshotLoaded={this.props.onSnapshotLoaded}
          model={this.props.model}
          legends={this.props.model.legends}
          componentId={UniqueIdGenerator.id()} />;
        break;
      }
      case WidgetType.CONTROL_WIDGET: {
        innerWidget = <ControlWidget widget={this.props.widget} />;
        break;
      }
      case WidgetType.TECHNICAL_ANALYSIS_CHART: {
        innerWidget =
          <TechnicalAnalysisWidget
            widget={this.props.widget}
            togglePreloader={this.togglePreloader}
            onSnapshotLoaded={this.props.onSnapshotLoaded} />;
        break;
      }
      case WidgetType.MAP: {
        innerWidget = <MapWidget />;
        break;
      }
      case WidgetType.SPREADSHEET: {
        innerWidget = <SpreadsheetWidget />;
        break;
      }
      case WidgetType.BULLET_VERTICAL: {
        innerWidget = <BulletWidget widget={this.props.model}
          togglePreloader={this.togglePreloader}
          componentId={UniqueIdGenerator.id()} />;
        break;
      }
      case WidgetType.SEPARATOR_VERTICAL: {
        innerWidget = <SeparatorWidget />;
        break;
      }
      case WidgetType.RANK_WIDGET: {
        innerWidget = <RankingWidget widget={this.props.model}
          togglePreloader={this.togglePreloader}
          componentId={UniqueIdGenerator.id()} />;
          break;
      }
      case WidgetType.TRADING_VIEW: {
        innerWidget = <TradingViewWidget widget={this.props.model} />
      }
    }

    ReactDOM.render(innerWidget
      , this.refs.innerWidget);
  }

  shouldComponentUpdate() {
    return false;
  }

  onEditButtonClick() {
    if (this.props.widget.type === WidgetType.CONTROL_WIDGET) {
      this.publish(InternalEvent.Dashboard.EDIT_CONTROL_WIDGET, this.props.widget);
    } else {
      let editingWidget = {
        id: this.props.widget.id,
        type: this.props.widget.type
      };
      this.props.onWidgetEdit(editingWidget);
    }
  }

  onCopyButtonClick() {
    let copyingWidget = {
      id: this.props.widget.id,
      type: this.props.widget.type
    };
    this.props.onWidgetCopy(copyingWidget);
  }

  onRemoveButtonClick() {
    this.publish(InternalEvent.App.SHOW_APP_MODAL, {
      onAgree: () => {
        if (this.props.widget.type === WidgetType.CONTROL_WIDGET) {
          this.removeDashboardVariable()
            .then(result => {
              if (result) {
                this.props.onWidgetRemove(this.props.widget.id);
              } else {
                this.publish(InternalEvent.App.SHOW_APP_MODAL, { type: "notify", header: "Dashboard variable in use." });
              }
            });
        } else {
          this.props.onWidgetRemove(this.props.widget.id);
        }
      },
      header: "Do you really want to remove?"
    });
  }

  removeDashboardVariable() {
    // todo: check selection control usage
    const metaData = this.props.widget.metaData;
    const variableId = ["selection", "dataset"].indexOf(metaData.type) > -1 ? metaData.variables[0].id : metaData.variable.id;
    let variableInUse = false;
    return DashboardService.getCurrentDashboard()
      .then(dashboard => {
        dashboard.state.dashboardState.forEach(state => {
          if (!variableInUse) {
            variableInUse = this.checkVariableInUse(state, variableId)
          }
        });

        if (variableInUse) {
          return false;
        } else {
          delete dashboard.variables[variableId];

          // delete unused dashboard variables
          variableInUse = false;
          for (let vId in dashboard.variables) {
            dashboard.state.dashboardState.forEach(state => {
              if (!variableInUse) {
                variableInUse = this.checkVariableInUse(state, vId)
              }
            });
            if (!variableInUse && vId !== 'lockDashboard') {
              delete dashboard.variables[vId];
            }
          }
          DashboardService.updateDashboard(dashboard, dashboard);
          return true;
        }
      });
  }

  checkVariableInUse(dashboardState, variableId) {
    let inUse = false;
    const widgetModel = dashboardState.widgetModel;
    widgetModel.legends.forEach(l => {
      if (l.expressions.y != null && l.expressions.y.indexOf(variableId) > -1) {
        if (widgetModel.type !== WidgetType.CONTROL_WIDGET) {
          inUse = true;
        }
      }
    });
    return inUse;
  }

  onStateChange(state) {
    WidgetService.updateWidgetLegends(this.props.widget.id, state.legends);
    this.props.onStateChange();
  }

  onRealtimeResumeButtonClick() {
    let isMaximized = $(".icon-size-actual") != null;
    this.publish(InternalEvent.Widget.REALTIME_RESUMED, {
      widgetId: this.props.widget.id,
      maximized: this.props.isMaximized
    });
  }

  togglePreloader(show) {
    let preloader = $(this.refs.container).find(".chart-preloader");

    if (show && !preloader.is(":visible")) {
      preloader.show();
    }

    if (!show) {
      preloader.hide();
    }
  }

  onToggleMaximize(e) {
    this.props.toggleMaximize(e);
  }

  render() {
    let header, title;
    if (this.props.widget.title.length > 0 && this.props.widget.type !== WidgetType.CONTROL_WIDGET) {
      title = <div name="widgetTitle">{this.props.widget.title}</div>;
    }

    const preloaderClass = !this.props.widget.metaData.useLargeSpinner ?
      "ball-grid-pulse chart-preloader chart-preloader-big" : "ball-grid-pulse chart-preloader";

    const preloader = <div className={preloaderClass}>
      <div />
      <div />
      <div />
      <div />
      <div />
      <div />
      <div />
      <div />
      <div />
    </div>;

    header = <div className="widget-header">
      {title}
      {!this.props.widget.metaData.useLargeSpinner ? null : preloader}
    </div>;

    let toggleIconClass = this.props.isMaximized ? "icon-size-actual" : "icon-size-fullscreen";
    let resumeRealTimeUpdateButton;
    let widgetActions, widgetMoveBtn;

    if (this.props.isPreviewWidget === false) {
      widgetActions = <WidgetActions ref="actions"
        widgetType={this.props.widget.type}
        widgetId={this.props.widget.id}
        toggleMaximize={this.onToggleMaximize}
        isMaximize={this.props.isMaximized}
        onRealtimeResumeButtonClick={this.onRealtimeResumeButtonClick}
        onEditButtonClick={this.onEditButtonClick}
        onRemoveButtonClick={this.onRemoveButtonClick}
        onCopyButtonClick={this.onCopyButtonClick}
        toggleIconClass={toggleIconClass} />;
      widgetMoveBtn = <div className={styles.moveBtn}>
        <i className="icon-cursor-move wrapper-icon grid-move-btn" />
      </div>;
    } else {
      resumeRealTimeUpdateButton = null;
    }
    return (
      <div className={["widget-container", styles.container].join(" ")}
        data-widget-id={this.props.widget.id}
        data-widget-type={this.props.widget.type} ref="container">
        {widgetMoveBtn}
        {header}
        <div ref="innerWidget" style={{ width: "100%", height: "100%" }}></div>
        {resumeRealTimeUpdateButton}
        {widgetActions}
        {!this.props.widget.metaData.useLargeSpinner ? preloader : null}
      </div>
    );
  }
}

WrapperWidget.propTypes = {
  widget: React.PropTypes.instanceOf(Widget).isRequired
};


// WEBPACK FOOTER //
// ./src/components/dashboard/widgets/wrapperWidget.jsx